import { Component, ViewChild, HostListener } from '@angular/core';
import { CompraFotosService } from "../core/services/compraFotos.service";
import {
  CompraFotoBackendError,
  CompraFotoEntradasInfo, CompraFotoErrorCode,
  CompraFotoPayload, CompraFotoProceedToPayResponse,
  MenorFotoPayload
} from "@lib/models/compra-foto.interface";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import { Subscription } from "rxjs";
import Swal from "sweetalert2";
import { FormFotoComponent } from '../form-foto/form-foto.component';
import {CompraFotoReservationService} from "../core/services/CompraFotoReservationService";
import { ActivatedRoute, Router } from "@angular/router";
import {
  dniValidator,
  formatPartidoLiteral,
  normalizeDni,
  normalizeEmail,
  normalizePhone,
  normalizeWhitespace,
  telefonoValidator,
  codigoPostalValidator
} from "@lib/utils/compra-foto-utils";
import {formatDate} from "@angular/common";
import { HttpErrorResponse } from '@angular/common/http';
import { EventSummary } from '@lib/models/event-summary.interface';


@Component({
  selector: 'fotos-compra-foto',
  templateUrl: './compra-foto.component.html',
  styleUrls: ['./compra-foto.component.scss']
})
export class CompraFotoComponent {

  partidos: EventSummary[] = [];
  selectedPartido: number | null = null;

  entradasInfo: CompraFotoEntradasInfo | null = null;
  selectedNumeroEntradas = 0;

  compradorForm!: FormGroup;
  entradasForm!: FormGroup;
  @ViewChild(FormFotoComponent) socioForm?: FormFotoComponent;

  showPartidoRetry = false;
  showEntradasRetry = false;
  entradasDisabled = false
  partidoDisabled = false
  formatPartidoLiteral = formatPartidoLiteral;

  resumenEntradas: any = null;

  stepInfo = {
    steps: [
      { id: 1, state: StepState.ACTIVE },
      { id: 2, state: StepState.DISABLED },
      { id: 3, state: StepState.DISABLED }
    ]
  };
  currentStep = 1
  statusResult: 'correcto' | 'error' | null = null;
  private statusParam: string | null = null;

  check1 = false;
  check2 = false;
  check3 = false;
  check4 = false;
  check5 = false;

  private activitySubscriptions: Subscription[] = [];
  private reservationSubscription?: Subscription;
  private expirationModalOpen = false;

  constructor(
    private compraFotoService: CompraFotosService,
    private fb: FormBuilder,
    private readonly reservationService: CompraFotoReservationService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.setupReservationListeners();
    this.route.paramMap.subscribe((params) => {
      this.statusParam = params.get('status');
      this.applyStatusRoute();
    });
    this.getNextHomeGames();
    this.initForms();
    this.reservationService.registerActivity();
    this.applyStatusRoute();
  }

  ngOnDestroy(): void {
    this.reservationService.dispose();
    this.reservationSubscription?.unsubscribe();
    this.activitySubscriptions.forEach((sub) => sub.unsubscribe());
  }

  onResumenChanged(resumen: any): void {
    this.resumenEntradas = resumen;
  }

  private setupReservationListeners(): void {
    this.reservationSubscription = this.reservationService.reservationExpired$.subscribe((message) => {
      if (this.expirationModalOpen) {
        return;
      }
      this.showReservationExpiredModal(message);
    });
  }

  private showReservationExpiredModal(message?: string): void {
    this.expirationModalOpen = true;
    Swal.fire({
      text: message ?? 'Se acabó el tiempo para la reserva. Se recargará la página.',
      icon: 'error',
      iconColor: '#008835',
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#008835'
    }).then(() => {
      window.location.reload();
    });
  }

  initForms() {

    //SOCIO
    if (this.socioForm?.formulario) {
      const socioSubscription = this.socioForm.formulario.valueChanges.subscribe(() =>
        this.reservationService.registerActivity()
      );
      this.activitySubscriptions.push(socioSubscription);
    }

    //COMPRADOR
    this.compradorForm = this.fb.group({
      nombreComprador: ['', Validators.required],
      apellidosComprador: ['', Validators.required],
      dniComprador: ['', [Validators.required, dniValidator]]//,
    });
      // emailComprador: ['', [Validators.required, Validators.email]],
      // telefonoComprador: ['', [Validators.required, telefonoValidator]],
      // domicilioComprador: ['', Validators.required],
      // codigoPostalComprador: ['', [Validators.required, codigoPostalValidator]]});

    this.compradorForm.disable()

    this.registerCompradorActivity();

    //ENTRADAS DINÁMICAS
    this.entradasForm = this.fb.group({
      entradas: this.fb.array([]),
    });

  }

  getNextHomeGames() {
    this.callPartidos()
  }

  get fechaPartidoSeleccionado(): string {
    if (!this.partidos || !this.selectedPartido) return 'Fecha no disponible';

    const partido = this.partidos.find(p => p?.id === this.selectedPartido);
    if (!partido?.edate) return 'Fecha no disponible';

    const fecha = new Date(partido.edate.replace(' ', 'T')); // parseamos correctamente el formato con "T"
    return formatDate(fecha, "EEEE d 'de' MMMM 'de' yyyy", 'es-ES');
  }

  get fechaPartidoDate(): Date | null {
    if (!this.partidos || !this.selectedPartido) return null;
    const partido = this.partidos.find(p => p?.id === this.selectedPartido);
    if (!partido?.edate) return null;
    return new Date(partido.edate.replace(' ', 'T'));
  }

  get horaPartidoSeleccionado(): string {
    if (!this.partidos || !this.selectedPartido) return 'Hora no disponible';

    const partido = this.partidos.find(p => p?.id === this.selectedPartido);
    if (!partido?.edate) return 'Hora no disponible';

    const fecha = new Date(partido.edate.replace(' ', 'T'));
    return fecha.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
  }

  callPartidos(){
    this.compraFotoService.getUpcomingHomeGames().subscribe({
      next: data => {
        this.partidos = data;
        this.showPartidoRetry = false;
      },
      error: () => {
        this.showPartidoRetry = true;
      }
    });
  }

  callEntradas(){
    this.compraFotoService.getEntradasInfoByEventId(this.selectedPartido!).subscribe({
      next: data=>{
        this.entradasInfo = data;
        this.reservationService.applyEntradasConfig(data)
        this.showEntradasRetry = false;
        this.reservationService.registerActivity();
      },
      error: () => {
        this.showEntradasRetry = true;
      }
    })
  }

  onPartidoSeleccionado() {
    if (this.selectedPartido == null) return;

    this.partidoDisabled = true
    this.callEntradas()
  }

  getEntradasAvailableToBuy(): number {
    if (!this.entradasInfo) return 0;

    const available = this.entradasInfo.stockAvailable ?? 0;
    const max = this.entradasInfo.maxPerBuyer ?? 0;
    return Math.min(available, max);
  }

  onEntradasSelected(numeroEntradas: number) {

    if (!numeroEntradas || !this.selectedPartido) {
      return;
    }

    const compradorRaw = this.compradorForm.getRawValue();

    const participantes = Array.from({ length: numeroEntradas }, () => ({} as MenorFotoPayload));

    const payload = {
      eventoId: this.selectedPartido,
      nombreComprador: normalizeWhitespace(compradorRaw.nombreComprador),
      apellidosComprador: normalizeWhitespace(compradorRaw.apellidosComprador),
      dniComprador: normalizeDni(compradorRaw.dniComprador),
      // emailComprador: normalizeEmail(compradorRaw.emailComprador),
      // telefonoComprador: normalizePhone(compradorRaw.telefonoComprador),
      // domicilioComprador: normalizeWhitespace(compradorRaw.domicilioComprador),
      // codigoPostalComprador: normalizeWhitespace(compradorRaw.codigoPostalComprador),
      totalCompra: null,
      participantes: participantes
    };

    this.compraFotoService.persistCompra(payload).subscribe({
      next: (compra) => {
        this.reservationService.startReservation(compra);
        this.selectedNumeroEntradas = numeroEntradas;
        this.reservationService.registerActivity();
        this.compradorForm.enable();
        this.entradasDisabled = true;
      },
      error: () => {
        this.reservationService.triggerExpiration(
          'No se ha podido iniciar la reserva temporal. Inténtalo de nuevo.',
          true
        );
      }
    });

  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    if (this.reservationActive) {
      this.reservationService.cancelReservationOnExit();
      event.preventDefault();
      event.returnValue = '';
    }
  }

  @HostListener('window:pagehide')
  onPageHide(): void {
    if (this.reservationActive) {
      this.reservationService.cancelReservationOnExit();
    }
  }

  private registerCompradorActivity(): void {
    const subscription = this.compradorForm.valueChanges.subscribe(() =>
      this.reservationService.registerActivity()
    );
    this.activitySubscriptions.push(subscription);
  }

  resetEntradasProcess(): void {
    this.performCancel({ refreshEntradas: true });
  }

  resetPartidoProcess(): void {
    this.performCancel({ resetPartido: true });
  }

  nextStep(): void {
    const currentIndex = this.stepInfo.steps.findIndex((s) => s.state === StepState.ACTIVE);

    if (currentIndex !== -1) {
      this.stepInfo.steps[currentIndex].state = StepState.COMPLETED;
      if (this.stepInfo.steps[currentIndex + 1]) {
        this.stepInfo.steps[currentIndex + 1].state = StepState.ACTIVE;
      }
    }
  }

  cancel(): void {

    if (!this.reservationActive) {
      return;
    }

    Swal.fire({
      title: 'Cancelar compra',
      text: 'Si cancela el proceso deberá volver a iniciarlo. ¿Desea continuar?',
      icon: 'warning',
      iconColor: '#008835',
      showCancelButton: true,
      confirmButtonText: 'Sí, cancelar',
      cancelButtonText: 'No',
      confirmButtonColor: '#008835',
      cancelButtonColor: '#9E9E9E'
    }).then(result => {
      if (result.isConfirmed) {
        this.cancelAndReload()
      }
    });
  }

  private performCancel(options: { resetPartido?: boolean; showFeedback?: boolean; refreshEntradas?: boolean } = {}): void {
    const { resetPartido = false, showFeedback = false, refreshEntradas = false } = options;

    const handleSuccess = () => {
      this.resetStateAfterCancel(resetPartido, refreshEntradas);

      if (showFeedback) {
        Swal.fire({
          text: 'La reserva se ha cancelado correctamente.',
          icon: 'success',
          iconColor: '#008835',
          confirmButtonText: 'ACEPTAR',
          confirmButtonColor: '#008835'
        });
      }
    };

    this.reservationService.cancelReservation().subscribe({
      next: () => handleSuccess(),
      error: (error) => {
        console.error('Error al cancelar la reserva de la foto:', error);
        if (showFeedback) {
          Swal.fire({
            text: 'No se ha podido cancelar la reserva. Inténtelo de nuevo.',
            icon: 'error',
            iconColor: '#008835',
            confirmButtonText: 'ACEPTAR',
            confirmButtonColor: '#008835'
          });
        }
      }
    });
  }

  cancelAndReload(): void {
    if (!this.reservationService.hasReservationData()) {return;}

    this.reservationService.cancelReservation().subscribe({
      next: () => {
        window.location.reload();
      },
      error: (error) => {
        console.error('Error al cancelar la reserva de la foto:', error);
        Swal.fire({
          text: 'No se ha podido cancelar la reserva. Inténtelo de nuevo.',
          icon: 'error',
          iconColor: '#008835',
          confirmButtonText: 'ACEPTAR',
          confirmButtonColor: '#008835'
        });
      }
    });
  }

  get showTimer(): boolean {
    return this.reservationService.showTimerVisible;
  }

  get countdownText(): string {
    return this.reservationService.countdownDisplay;
  }

  get isExpiringSoon(): boolean {
    return this.reservationService.expiringSoon;
  }

  get reservationActive(): boolean {
    return this.reservationService.isReservationActive;
  }

  private resetStateAfterCancel(resetPartido: boolean, refreshEntradas: boolean): void {
    this.reservationService.resetEntradasConfig();

    this.selectedNumeroEntradas = 0;
    this.entradasDisabled = false;
    this.entradasInfo = null;

    this.compradorForm.disable();

    if (resetPartido) {
      this.selectedPartido = null;
      this.partidoDisabled = false;
    } else if (refreshEntradas && this.selectedPartido) {
      this.callEntradas();
    }
  }

  stepToPay(): void {
    this.socioForm?.triggerValidation();

    const campos: string[] = [];
    let edadInvalida = false;
    let babyCount = 0;

    if (!this.compradorForm?.valid) {
      const cf = this.compradorForm;
      Object.keys(cf.controls).forEach(key => {
        if (cf.get(key)?.invalid) {
          campos.push(this.formatDetailKey(key));
        }
      });
    }

    const fa = this.socioForm?.formulario?.get('entradas') as FormArray;
    const fechaPartido = this.fechaPartidoDate;

    if (fa) {
      fa.controls.forEach((ctrl, i) => {
        const menor = (ctrl as FormGroup).get('menor') as FormGroup;
        const resp = (ctrl as FormGroup).get('responsable') as FormGroup;

        if (menor) {
          const fechaNac = menor.get('fecha_nacimiento')?.value;
          const nombre = menor.get('nombre')?.value;
          const apellidos = menor.get('apellidos')?.value;

          if (!nombre) campos.push(`Entrada ${i + 1} - Menor: nombre`);
          if (!apellidos) campos.push(`Entrada ${i + 1} - Menor: apellidos`);

          if (!fechaNac) {
            campos.push(`Entrada ${i + 1} - Menor: fecha de nacimiento`);
          } else if (fechaPartido) {
            const fn = new Date(fechaNac);
            const edad = fechaPartido.getFullYear() - fn.getFullYear();
            const m = fechaPartido.getMonth() - fn.getMonth();
            const edadFinal = (m < 0 || (m === 0 && fechaPartido.getDate() < fn.getDate())) ? edad - 1 : edad;

            if (edadFinal >= 0 && edadFinal < 3) {
              babyCount++;
            }

            if (edadFinal < 0 || edadFinal > 13) {
              edadInvalida = true;
              const fechaCtrl = menor.get('fecha_nacimiento');
              fechaCtrl?.setErrors({ edadNoValida: true });
              fechaCtrl?.markAsTouched();
              fechaCtrl?.markAsDirty();
            }
          }
        }

        if (resp?.invalid) {
          Object.keys(resp.controls).forEach(k => {
            if (resp.get(k)?.invalid) {
              campos.push(`Entrada ${i + 1} - Responsable: ${k}`);
            }
          });
        }
      });
    }

    if (campos.length > 0 || edadInvalida) {
      const titulo = edadInvalida ? 'Fecha de nacimiento no válida' : 'Campos incompletos';
      const mensaje = edadInvalida
        ? 'El menor debe tener entre 0 y 13 años el día del partido.'
        : 'Por favor, rellene todos los campos obligatorios antes de continuar.';

      Swal.fire({
        icon: 'warning',
        title: titulo,
        html: `<p style="text-align:left">${mensaje}</p>`,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#008835'
      });
      return;
    }

    if (babyCount > 0 && this.entradasInfo) {
      const babyAvailable = (this.entradasInfo.babyStockLimit ?? 0) - (this.entradasInfo.babyStockUsed ?? 0);
      if (babyCount > babyAvailable) {
        Swal.fire({
          icon: 'warning',
          title: 'Plazas para menores de 3 años completa',
          text: 'Ya se ha completado el cupo de plazas para menores de 3 años en este partido. Puedes seguir con la compra si el menor tiene 3 años o más.',
          confirmButtonColor: '#008835'
        });
        return;
      }
    }

    this.reservationService.registerActivity();
    this.nextStep();

    this.stepInfo.steps[0].state = StepState.COMPLETED;
    this.currentStep = 2;

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  get nombrePartidoSeleccionado(): string {
    if (!this.partidos || !this.selectedPartido) return 'Partido no seleccionado';
    const partido = this.partidos.find(p => p?.id === this.selectedPartido);
    return partido?.name || 'Partido no seleccionado';
  }

  proceedToPay(): void {
    if (!this.resumenEntradas) {
      Swal.fire({
        icon: 'warning',
        text: 'No hay información de resumen disponible para procesar el pago.',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#008835'
      });
      return;
    }

    if (!this.check1 || !this.check2 || !this.check3 || !this.check4) {
      Swal.fire({
        icon: 'warning',
        title: 'Acepte los términos',
        text: 'Debe aceptar las condiciones obligatorias para continuar.',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#008835'
      });
      return;
    }

    Swal.fire({
      title: 'Confirmar pago',
      html: `
      <p>¿Desea confirmar la compra de
      <strong>${(this.resumenEntradas.noAbonados.count + this.resumenEntradas.abonados.count) || 0}</strong> entradas?</p>
      <p style="margin-top:10px">Importe total:
      <strong>${this.resumenEntradas.total.toFixed(2)} €</strong></p>
    `,
      icon: 'question',
      iconColor: '#008835',
      showCancelButton: true,
      confirmButtonText: 'Sí, pagar ahora',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#008835',
      cancelButtonColor: '#9E9E9E'
    }).then((result) => {
      if (!result.isConfirmed) return;

      const entradasArray = this.entradasForm.get('entradas') as FormArray;
      const compradorRaw = this.compradorForm.getRawValue();

      const participantes: MenorFotoPayload[] = entradasArray.controls.map((control) => {
        const form = control as FormGroup;
        const responsable = (form.get('responsable') as FormGroup).value;
        const menor = (form.get('menor') as FormGroup).value;

        return {
          nombre: normalizeWhitespace(menor.nombre),
          apellidos: normalizeWhitespace(menor.apellidos),
          fechaNacimiento: normalizeWhitespace(menor.fecha_nacimiento),
          idAbonado: menor.id_abonado ? Number(menor.id_abonado) : null,
          check_abonado: menor.check_abonado,
          responsable: {
            nombre: normalizeWhitespace(responsable.nombre),
            apellidos: normalizeWhitespace(responsable.apellidos),
            dni: normalizeDni(responsable.dni),
            email: normalizeEmail(responsable.email),
            telefono: normalizePhone(responsable.telefono),
            domicilio: normalizeWhitespace(responsable.domicilio),
            codigoPostal: normalizeWhitespace(responsable.codigoPostal),
          },
        };
      });

      const payload: CompraFotoPayload = {
        eventoId: this.selectedPartido!,
        nombreComprador: normalizeWhitespace(compradorRaw.nombreComprador),
        apellidosComprador: normalizeWhitespace(compradorRaw.apellidosComprador),
        dniComprador: normalizeDni(compradorRaw.dniComprador),
        // emailComprador: normalizeEmail(compradorRaw.emailComprador),
        // telefonoComprador: normalizePhone(compradorRaw.telefonoComprador),
        // domicilioComprador: normalizeWhitespace(compradorRaw.domicilioComprador),
        // codigoPostalComprador: normalizeWhitespace(compradorRaw.codigoPostalComprador),
        totalCompra: this.resumenEntradas.total,
        participantes,
        condicionImagenAceptada: this.check5,
      };

      Swal.fire({
        title: 'Procesando pago...',
        text: 'Por favor, no cierre esta ventana.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      this.reservationService.proceedToPay(payload).subscribe({
        next: (response: any) => {
          Swal.close();
          this.reservationService.reservationTurnFalse()
          this.handleProceedToPaySuccess(response);
        },
        error: (error) => {
          Swal.close();
          this.handleProceedToPayError(error);
        }
      });
    });
  }

  //region Gestión de errores - modal
  private handleProceedToPaySuccess(response: CompraFotoProceedToPayResponse): void {
    Swal.close();

    if (!response?.result) {
      this.handleProceedToPayError(new Error(response?.message ?? 'No se pudo completar el proceso de pago.'));
      return;
    }

    if (response?.message) {
      window.location.href = response.message;
      return;
    }

    Swal.fire({
      icon: 'success',
      title: 'Pago iniciado',
      text: 'Se ha iniciado correctamente el proceso de pago.',
      confirmButtonColor: '#008835'
    });
  }

  private handleProceedToPayError(error: unknown): void {
    Swal.close(); // cerramos el loading si estaba activo

    let code: CompraFotoErrorCode | undefined;
    let message = 'Ha ocurrido un error inesperado.';
    let details: string[] = [];

if (error instanceof HttpErrorResponse) {
  const backendError = error.error as CompraFotoBackendError | string | null;

  if (backendError && typeof backendError === 'object') {
    code = backendError.errorCode;
    message = backendError.message || this.getErrorMessage(code);
    details = this.extractErrorDetails(backendError.details);

    if (
      code === 'FORM_VALIDATION_ERROR' &&
      message.includes('rango de edad permitido')
    ) {
      Swal.fire({
        icon: 'warning',
        title: 'Edad no permitida',
        text: 'El menor no puede tener más de 13 años el día del partido.',
        confirmButtonColor: '#008835'
      });
      return;
    }

  } else if (typeof backendError === 'string') {
    message = backendError;
  }
} else if (error instanceof Error) {
  message = error.message;
}

    // Clasificación de errores
    const reloadErrors: CompraFotoErrorCode[] = ['TOKEN_INVALID', 'TOKEN_EXPIRED', 'UNAUTHORIZED_ACCESS', 'RESERVATION_NOT_ACTIVE'];
    const retryErrors: CompraFotoErrorCode[] = ['PAYMENT_ERROR'];
    const editableErrors: CompraFotoErrorCode[] = ['FORM_VALIDATION_ERROR', 'EVENT_NOT_VALID', 'NO_STOCK_AVAILABLE', 'BABY_STOCK_FULL'];

    const shouldReload = !!code && reloadErrors.includes(code);
    const canRetry = !!code && retryErrors.includes(code);
    const canEdit = !!code && editableErrors.includes(code);

    let actionHint = '';
    if (shouldReload) {
      actionHint = 'Recarga la página para iniciar una nueva compra.';
    } else if (canRetry) {
      actionHint = 'Puedes intentar iniciar el pago de nuevo desde aquí.';
    } else if (canEdit) {
      actionHint = 'Puedes volver atrás y modificar la información antes de intentarlo de nuevo.';
    } else {
      actionHint = 'Si el problema persiste ponte en contacto con el club.';
    }

    const cancelButtonText = code === 'EVENT_NOT_VALID'
      ? 'Elegir otro partido'
      : code === 'NO_STOCK_AVAILABLE'
        ? 'Modificar plazas'
        : code === 'BABY_STOCK_FULL'
          ? 'Corregir edades'
          : 'Editar datos';


    const actionHintStyle = canEdit
      ? 'margin-top:12px;font-size:0.78rem;color:#666;'
      : 'margin-top:12px;font-size:0.95rem;color:#444;';

    const html = `
      <p>${message}</p>
      ${details.length ? `<ul style="text-align:left;margin-top:8px">${details.map(d => `<li>${d}</li>`).join('')}</ul>` : ''}
      ${actionHint ? `<p style="${actionHintStyle}">${actionHint}</p>` : ''}
      ${code ? `<p style="margin-top:10px;font-size:0.9rem;color:#666;">Código de error: <strong>${code}</strong></p>` : ''}
    `;

    const buttons: any = {
      icon: 'error',
      iconColor: '#008835',
      title: 'No se pudo completar el pago',
      html,
      confirmButtonColor: '#008835',
      confirmButtonText: shouldReload ? 'Recargar página' : 'Aceptar',
      showCancelButton: canEdit,
      showDenyButton: canRetry,
      denyButtonText: 'Reintentar pago',
      denyButtonColor: '#4CAF50',
      allowOutsideClick: false
    };

    if (canEdit) {
      buttons.cancelButtonText = cancelButtonText;
    }

    Swal.fire(buttons).then((result) => {
      if (shouldReload) {
        window.location.reload();
        return;
      }

      if (result.isDenied && canRetry) {
        this.proceedToPay();
        return;
      }

      if (canEdit && result.dismiss === Swal.DismissReason.cancel) {
        this.stepBack();
      }

    });
  }

  private getErrorMessage(code?: CompraFotoErrorCode): string {
    switch (code) {
      case 'FORM_VALIDATION_ERROR':
        return 'Revisa los datos introducidos antes de continuar.';
      case 'NOT_VALID_DATA':
        return 'No hemos podido validar la reserva. Inténtalo de nuevo más tarde.';
      case 'EVENT_NOT_VALID':
        return 'El partido seleccionado ya no está disponible. Vuelve atrás y elige otro.';
      case 'NO_STOCK_AVAILABLE':
        return 'No quedan plazas disponibles para este encuentro.';
      case 'PAYMENT_ERROR':
        return 'Se ha producido un problema al iniciar el pago. Inténtalo de nuevo.';
      case 'RESERVATION_NOT_ACTIVE':
        return 'La reserva ya no está activa. Inicia una nueva compra.';
      case 'TOKEN_INVALID':
      case 'UNAUTHORIZED_ACCESS':
        return 'La sesión ha caducado o no es válida. Reinicia el proceso.';
      case 'TOKEN_EXPIRED':
        return 'El tiempo de la reserva ha expirado. Inicia una nueva compra.';
      case 'BABY_STOCK_FULL':
        return 'Ya se ha completado el cupo de plazas para menores de 3 años en este partido.';
      default:
        return 'Ha ocurrido un error inesperado al procesar el pago.';
    }
  }

  private extractErrorDetails(details: Record<string, unknown> | null | undefined): string[] {
    if (!details) return [];
    return Object.entries(details)
      .filter(([, v]) => v != null && `${v}`.trim().length > 0)
      .map(([k, v]) => `${this.formatDetailKey(k)}: ${v}`);
  }

  private formatDetailKey(key: string): string {
    const spaced = key.replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').trim();
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
  }

  //endregion

  stepBack(){

    this.currentStep = 1

    this.stepInfo.steps[0].state = StepState.ACTIVE;
    this.stepInfo.steps[1].state = StepState.DISABLED;
  }

  goToStart(): void {
    this.router.navigate(['/compra-foto']);
  }

  private applyStatusRoute(): void {
    if (this.statusParam !== 'correcto' && this.statusParam !== 'error') {
      this.statusResult = null;
      return;
    }

    this.statusResult = this.statusParam as 'correcto' | 'error';
    this.currentStep = 3;
    this.stepInfo.steps[0].state = StepState.COMPLETED;
    this.stepInfo.steps[1].state = StepState.COMPLETED;
    this.stepInfo.steps[2].state = StepState.ACTIVE;
    this.reservationService.showTimerVisible = false;
    this.compradorForm?.disable();
    this.entradasForm?.disable();
    this.entradasDisabled = true;
    this.partidoDisabled = true;
  }

  get canGoStepBack(): boolean  {
    return this.currentStep === 2;
  }

  get canGoToPay(): boolean {
    if (!this.compradorForm?.valid) return false;
    if (!this.socioForm?.formulario?.valid) return false;
    if (!this.selectedNumeroEntradas) return false;
    if (!this.selectedPartido) return false;
    return true;
  }


}

export enum StepState {
  ACTIVE = 'active',
  COMPLETED = 'completed',
  DISABLED = 'disabled'
}


